<template>
  <div class="flag-container">
    <el-popover
      v-if="subscribed"
      placement="bottom"
      trigger="hover"
      width="300"
      :disabled="!(hub || reports.length)"
      :open-delay="200"
      :close-delay="100"
      @show="selectPopover(tid)"
      @hide="selectPopover(null)"
    >
      <div class="recent-articles">
        <nuxt-link v-if="hub" :to="hub"> {{ name }} Hub </nuxt-link>
      </div>
      <div
        v-for="article in reports"
        :key="article.nid"
        class="recent-articles"
      >
        <nuxt-link :to="article.url">
          {{ article.title }}
        </nuxt-link>
      </div>
      <div slot="reference">
        <Country
          class="flags"
          :text="name"
          :link="link"
          :iso="iso"
          :access="subscribed == 1 ? true : false"
          :icon="flag"
          size="small"
        />
      </div>
    </el-popover>
    <div v-if="!subscribed" slot="reference">
      <Country
        class="flags"
        :class="subscribed == 0 ? 'transparent' : null"
        :text="name"
        :link="link"
        :iso="iso"
        :access="subscribed == 1 ? true : false"
        :icon="flag"
        size="small"
      />
      <Tooltip :size="'small'" />
    </div>
  </div>
</template>

<script>
export default {
  // components: {
  //   Tooltip: () => import("./Tooltip"),
  // },
  props: {
    link: {
      type: String,
      default: null,
    },
    iso: {
      type: String,
      default: null,
    },
    name: {
      type: String,
      default: "",
    },
    tid: {
      type: Number,
      default: 0,
    },
    hub: {
      type: String,
      default: "",
    },
    reports: {
      type: Array,
      default: () => [],
    },
    flag: {
      type: String,
      default: "",
    },
    // eslint-disable-next-line vue/prop-name-casing
    product_access: {
      type: Boolean,
      default: false,
    },
    subscribed: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    selectPopover(id) {
      this.$emit("popOverChange", id);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/helpers/variables";
@import "../../assets/styles/helpers/mixin";
.recent-articles {
  display: flex;
  flex-direction: column;

  a {
    width: 100%;
    font-weight: 600;
    font-size: 1.6rem;
    color: $black;
    text-decoration: none;
    text-align: center;
    display: inline-block;
    margin: 1rem 0;
    padding: 0.8rem 1.6rem;
    border: 1px solid $border;
    border-radius: 0.4rem;
    word-break: initial;
  }
}

.flags {
  margin-bottom: 0.5rem;
}

.flag-container {
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding-bottom: 2rem;
  position: relative;

  &:hover {
    .tooltip {
      display: block;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
    }
  }
}

.transparent {
  opacity: 0.25;
}
</style>
